import React, { Component } from 'react';
import { Recover } from '$components/auth';
import { recover } from '$actions/accounts';
import { changeTitle } from '$actions/root';
import { formSelector } from '$selectors';
import { connect } from 'react-redux';
import {Translate} from "$common";

@connect(state => ({
  form: formSelector(state, 'recover')
}), { recover, changeTitle })
export default class RecoverRoute extends Component {
  componentWillMount() {
    this.props.changeTitle(Translate.get('edit_profile'))
  }

  render() {
    const { form, recover } = this.props;

    return (
      <Recover
        errors={form.errors}
        onSubmit={recover}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/auth/recover.js